import { AxiosResponse } from "axios";
import { studioAxiosInstance } from "./instances";
import { ENDPOINTS } from "./endpoints";
import { IHistoryResponseData } from "../../redux/reducers/history/historyTypes";

export const getHistoryListAPI = async ({
  userId,
  page,
  pageSize,
}: {
  userId: number;
  page: number;
  pageSize: number;
}): Promise<AxiosResponse<IHistoryResponseData>> => {
  return await studioAxiosInstance.get(
    `${ENDPOINTS.HISTORY.LIST(userId)}?pageSize=${pageSize}&page=${page}`
  );
};

export const deleteHistoryItemAPI = async (
  historyHash: string
): Promise<AxiosResponse<IHistoryResponseData>> => {
  const response = await studioAxiosInstance.delete(
    `${ENDPOINTS.HISTORY.DELETE}/${historyHash}`
  );

  return response;
};
